import React, { useCallback, useState } from "react";
import dayjs from "dayjs";
import { CalendarPanel } from "@components/pages/History/components/TransactionDateRangePicker/TransactionDateRangePicker.views";
import { computeRangeAfterClick } from "@components/pages/History/components/TransactionDateRangePicker/transactionDateRangePicker.helpers";

import "@components/pages/History/components/TransactionDateRangePicker/TransactionDateRangePicker.sass";
import "./TradingCustomRangeCalendar.sass";

function createInitialLeftPanel() {
  return {
    viewMode: "days",
    viewMonth: dayjs().subtract(1, "month").startOf("month"),
  };
}

function createInitialRightPanel() {
  return {
    viewMode: "days",
    viewMonth: dayjs().startOf("month"),
  };
}

function parseCustomRangeToPending(customRange) {
  if (!customRange?.dateFrom || !customRange?.dateTo) {
    return { from: null, to: null };
  }
  const from = dayjs(customRange.dateFrom);
  const to = dayjs(customRange.dateTo);
  if (!from.isValid() || !to.isValid()) {
    return { from: null, to: null };
  }
  return { from: from.startOf("day"), to: to.startOf("day") };
}

function formatDayjsForTradingRange(date) {
  return date.format("YYYY-MM-DD");
}

/**
 * @param {{
 *   customRange?: { dateFrom: string | null, dateTo: string | null },
 *   onApply: (range: { dateFrom: string, dateTo: string }) => void,
 * }} props
 */
export const TradingCustomRangeCalendar = ({ customRange, onApply }) => {
  const initialPending = parseCustomRangeToPending(customRange);
  const [pendingFrom, setPendingFrom] = useState(initialPending.from);
  const [pendingTo, setPendingTo] = useState(initialPending.to);
  const [leftPanel, setLeftPanel] = useState(createInitialLeftPanel);
  const [rightPanel, setRightPanel] = useState(createInitialRightPanel);

  const handleDayClick = useCallback(
    (clicked) => {
      const next = computeRangeAfterClick(pendingFrom, pendingTo, clicked);
      setPendingFrom(next.from);
      setPendingTo(next.to);

      if (next.from && next.to) {
        onApply({
          dateFrom: formatDayjsForTradingRange(next.from),
          dateTo: formatDayjsForTradingRange(next.to),
        });
      }
    },
    [pendingFrom, pendingTo, onApply],
  );

  const minNavMonth = dayjs("2026-01-01").startOf("month");
  const maxNavMonth = dayjs().startOf("month");

  return (
    <div className="trading-calendar-card__custom-range-picker tx-date-range-picker trading-calendar-card__custom-range-picker--adaptive">
      <div className="trading-calendar-card__custom-range-picker-body tx-date-range-picker__body">
        <CalendarPanel
          panel={leftPanel}
          setPanel={setLeftPanel}
          pendingFrom={pendingFrom}
          pendingTo={pendingTo}
          onDayClick={handleDayClick}
          showNav={false}
          minNavMonth={minNavMonth}
          maxNavMonth={maxNavMonth}
        />
        <CalendarPanel
          panel={rightPanel}
          setPanel={setRightPanel}
          pendingFrom={pendingFrom}
          pendingTo={pendingTo}
          onDayClick={handleDayClick}
          showNav={false}
          minNavMonth={minNavMonth}
          maxNavMonth={maxNavMonth}
        />
      </div>
    </div>
  );
};

export default TradingCustomRangeCalendar;
